<template>
    <div class="CustomChip" :style="{ '--chip-bg-colour': bgColour }">
        <div
            v-if="icon"
            class="CustomChip__icon"
            :class="{
                'CustomChip__icon--rotate': icon.toLowerCase() === 'platform12',
            }"
        >
            <FontIcon
                :icon="icon.toLowerCase()"
                :style="{ '--font-icon-colour': iconColour }"
                size="stretch"
            />
        </div>
        <img
            v-if="image?.url"
            :src="image.url"
            loading="lazy"
            class="CustomChip__image"
        />
    </div>
</template>

<script setup>
defineProps({
    bgColour: { type: String, default: '' },
    icon: { type: String, default: '' },
    iconColour: { type: String, default: '' },
    image: { type: Object, default: () => ({}) },
})
</script>

<style lang="scss" scoped>
.CustomChip {
    --chip-bg-colour: var(--chip-bg-colour, var(--black));

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2.5%;
    background-color: var(--chip-bg-colour);
    padding: 0.75rem 1rem;
    border-radius: 20rem;
}

.CustomChip__icon {
    width: 15%;
}

.CustomChip__icon--rotate {
    animation: rotate 7s infinite forwards linear;
}

.CustomChip__image {
    width: 80%;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
